// @flow

import { css } from 'styled-components';
import type { Interpolation } from 'styled-components';

export type BreakpointName = 'small' | 'medium' | 'large';

export const BREAKPOINTS = {
  small: 0,
  medium: 481,
  large: 769,
  extraLarge: 1280,
};

export function breakpoint(name: BreakpointName) {
  const pixels = BREAKPOINTS[name];

  if (pixels === 0) {
    return (
      strings: Array<string>,
      ...interpolations: Array<Interpolation>
    ) => {
      return css(strings, ...interpolations);
    };
  }

  return (strings: Array<string>, ...interpolations: Array<Interpolation>) => {
    return css`
      @media (min-width: ${pixels}px) {
        ${css(strings, ...interpolations)};
      }
    `;
  };
}
